import store from '@/store'
// 正式环境
const mjAppId = 'dingoarwn21xjjpanbofyn'// 麦匠-二维码登录appId
const kjAppId = 'dingoajadwmggldplmknjg' // 跨捷-二维码登录appId
const appIdMobile = 'dingoaqvpgytwm0sounctq'
const dfAppId = 'dingoafwobpiwr5ofuzqbg' // 德风-二维码登录appId
const redirect_uri = 'https://mj.seedear.net/' // 二维码登录回调地址

// 预发布相关
const preReleaseMjAppId = 'dingoanzrrvjhimmzbyodj' // 麦匠-二维码登录appId
const preReleaseKjAppId = 'dingoar1mq3wm57hom3bup' // 跨捷-二维码登录appId
const preReleaseDfAppId = 'dingoavte4dttgeznsgxco' // 德风-二维码登录appId
const preReleaseRedirectUri = 'https://mjdev.seedear.net/' // 二维码登录回调地址

const server_uri = process.env.VUE_APP_SERVER_URL
const site = ['US', 'UK', 'DE', 'CA', 'FR', 'IT', 'ES', 'JP']

// 不要使用
const getToken = 'Bearer ' + store.getters.token
export default {
  mjAppId,
  kjAppId,
  dfAppId,
  appIdMobile,
  redirect_uri,
  server_uri,
  site,
  getToken,

  // 预发布相关
  preReleaseMjAppId,
  preReleaseKjAppId,
  preReleaseDfAppId,
  preReleaseRedirectUri
}
